import BrowserInfo from './BrowserInfo'
import { PlaceInAkixiNameSpace } from './Utils'

// General JavaScript date/time functions.
//
// Copyright (c) 2019 Akixi Limited, All Rights Reserved.
//
// Redistribution and use in source and/or binary forms, with or without modification, is
// not permitted without the express permission of Akixi Limited.
//
/**
 * Returns a string presentation of the date object that is fully localised
 * if the users browser supports it. If it does not then the default string
 * representation of the date is return.
 * @param pDateObj The date object that is using the correct javascript
 * date/time format stated above.
 * @param pOptions JavaScript date/time options that format the string. See
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat#Parameters
 * for more details on the available options.
 * @returns {string} Representation of the date in the end users locale.
 */
function CFormatDate(pDateObj: string, pOptions: Intl.DateTimeFormatOptions): string {
    const pResolvedOptions = pOptions || {
        day: 'numeric',
        hour: '2-digit',
        hour12: false,
        minute: 'numeric',
        month: 'long',
        second: 'numeric',
        timeZoneName: 'long',
        weekday: 'long',
        year: 'numeric'
    }

    const iParseMilliseconds = Date.parse(pDateObj)
    // Format the date and time to a readible string.
    const sFormattedDate = new Date(iParseMilliseconds)
    const pBrowserInfo = BrowserInfo

    const bIsBrowserIEOrEdge = pBrowserInfo.IsBrowserIE() || pBrowserInfo.IsBrowserEdge()
    if (bIsBrowserIEOrEdge) {
        return sFormattedDate.toString()
    }
    return Intl.DateTimeFormat('default', pResolvedOptions).format(sFormattedDate)
}

export default CFormatDate

PlaceInAkixiNameSpace('CFormatDate', CFormatDate)
